import { compose, withProps, withHandlers, lifecycle } from "recompose";
import { withRouter } from "react-router";

const EnhancePaginatedPage = () =>
  compose(
    withProps((props) => {
      return {
        lastPage: Math.ceil(props.itemsCount / props.length),
      };
    }),
    withHandlers({
      updatePageQuery: (props) => (query, value) =>
        query && query.replace(/([?|&]page=)[^&]+/i, "$1" + value),
    }),
    withRouter,
    withHandlers({
      handleOutOfRangePageQuery: () => (props) => {
        if (!props.loading) {
          const lastPage = props.lastPage > 0 ? props.lastPage : 1;
          if (props.page > lastPage) {
            props.history.push(
              props.location.pathname +
                props.updatePageQuery(props.location.search, 1)
            );
          }
        }
      },
    }),
    lifecycle({
      UNSAFE_componentWillReceiveProps: function (nextProps) {
        this.props.handleOutOfRangePageQuery(nextProps);
      },
      UNSAFE_componentWillMount: function () {
        this.props.handleOutOfRangePageQuery(this.props);
      },
    })
  );

export default EnhancePaginatedPage;
